import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import GroupIcon from "@material-ui/icons/Group";
import { useUsersDetailsStyles } from "./styles";
import { Box, Button } from "@material-ui/core";
import { ChevronLeft } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import UsersDetailsInfo from "./components/Info";
import UsersDetailsTabs from "./components/Tabs";
import { useGetUser } from "../../../services/api-tansquery/user/details";

export default function UsersDetails() {
  const history = useHistory();
  const { classes } = useUsersDetailsStyles();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { id } = useParams<{ id: string }>();
  const { data: user, isLoading } = useGetUser(id);

  useEffect(() => {
    setBreadcrumbs((prev) => {
      const homeBreadcrumb = prev.find((_, index) => index === 0);
      return [
        homeBreadcrumb,
        {
          label: "Usuários",
          path: "/usuarios",
          icon: GroupIcon,
        },
        {
          label: "Informações",
          path: "",
        },
      ];
    });
  }, [setBreadcrumbs]);

  return (
    <Box className={classes.root}>
      <Box>
        <Button
          className={classes.backButton}
          startIcon={<ChevronLeft />}
          onClick={() => history.goBack()}
        >
          Voltar
        </Button>
      </Box>
      {isLoading ? (
        <Box className={classes.loading}>
            <span>Carregando informações...</span>  
        </Box>
      ) : user ? (
        <>
          <UsersDetailsInfo user={user} />
          <UsersDetailsTabs user={user} />
        </>
      ) : null}
    </Box>
  );
}
